import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserPermissions } from '../user-permissions/user-permissions';
import { UserPermissionsStorage } from '../user-permissions/user-permissions-storage';
import { findProtocolId } from '../shared/route-helpers';

@Injectable()
export class SponsorStudyPermissionsResolver implements Resolve<UserPermissions> {

    constructor(
        private readonly userPermissionsStorage: UserPermissionsStorage,
    ) { }

    public resolve(route: ActivatedRouteSnapshot): Observable<UserPermissions> {
        const protocolId = findProtocolId(route);

        return this.userPermissionsStorage.getPermissionsByStudy(protocolId);
    }
}